import { useLoggedInQuery } from '@/src/common/gql/MesaGql'
import { graphql } from '@api/mesa/gql'
import { useReferralStatsStore } from '../store/useReferralStatsStore'
import { useEffect } from 'react'

export function useReferralStats() {
  const { setReferralStats, referralStats } = useReferralStatsStore()
  const { data, ...rest } = useLoggedInQuery(
    graphql(`
      query GetReferralStats {
        getReferralStats {
          CARD {
            numberOfReferredMembers
            pointsEarned
          }
        }
      }
    `),
    { fetchPolicy: 'cache-and-network' },
  )

  useEffect(() => {
    if (data) {
      setReferralStats(data)
    }
  }, [data, setReferralStats])

  return {
    data: referralStats,
    ...rest,
  }
}
